import { Link } from "react-router";
import { BrandMark } from "~/components/layout";

/**
 * Fun 404 — joke thread: a phantom conference slot that never made the schedule.
 */
export function NotFoundPage() {
  return (
    <main className="nf">
      <div className="nf-wash" aria-hidden="true" />
      <div className="nf-blob nf-blob--a" aria-hidden="true" />
      <div className="nf-blob nf-blob--b" aria-hidden="true" />

      <div className="nf-inner">
        <div className="nf-brand nf-rise" style={{ animationDelay: "40ms" }}>
          <BrandMark variant="dark" endorseHref="https://timetosizzle.com" />
        </div>

        <div className="nf-hero">
          <div className="nf-404-wrap" aria-hidden="true">
            <span className="nf-404">404</span>
            <div className="nf-prop">
              <span className="nf-prop-chip">6:40 PM</span>
              <span className="nf-prop-label">never scheduled</span>
            </div>
          </div>

          <p className="nf-chip nf-rise" style={{ animationDelay: "80ms" }}>
            Slot not found · phantom booking
          </p>
          <h1 className="nf-title nf-rise" style={{ animationDelay: "140ms" }}>
            This time never made the board.
          </h1>
          <p className="nf-lead nf-rise" style={{ animationDelay: "200ms" }}>
            This URL isn&apos;t on tonight&apos;s schedule — no family is waiting in the hallway for it, and no
            teacher has it on their clipboard.
          </p>
          <p className="nf-aside nf-rise" style={{ animationDelay: "260ms" }}>
            We built SchoolConferenceGo so real conference nights stay full — not so ghost links get a
            chair.
          </p>

          <div className="nf-ctas nf-rise" style={{ animationDelay: "320ms" }}>
            <Link to="/" className="btn btn-primary nf-cta-primary">
              Back to home
            </Link>
            <Link to="/insights" className="btn btn-secondary nf-cta-secondary">
              Browse insights
            </Link>
            <Link to="/support" className="nf-soft-link">
              Think this is our mistake? Tell us.
            </Link>
          </div>
        </div>

        <ul className="nf-excuses nf-rise" style={{ animationDelay: "400ms" }}>
          <li>
            <strong>Typo in the link.</strong> The schedule doesn’t autocomplete.
          </li>
          <li>
            <strong>Old bookmark.</strong> That conference wrapped last season.
          </li>
          <li>
            <strong>We moved a page.</strong> Quietly — like a room change nobody announced.
          </li>
        </ul>
      </div>
    </main>
  );
}
